import React, { useEffect, useState } from 'react';
import { Card, Col, Input, Row } from 'antd';
import WABAForm from './WABAForm';
import WABAList from './WABAList';
import { useWabaMessageList } from './store';
const { Search } = Input;

const NotificationConfigure = () => {
    const [page, setPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState(null);
    const { fetchWabaList, wabaList } = useWabaMessageList();
    const [selectedWaba, setSelectedWaba] = useState(null);

    useEffect(() => {
        getDataForWaba(page, searchQuery);
    }, [page, searchQuery]);

    useEffect(() => {
        if (wabaList.length > 0 && !selectedWaba) {
            setSelectedWaba(wabaList[0]);
        }
    }, [wabaList]);

    const getDataForWaba = (pageNo = 1, searchKey) => {
        fetchWabaList({ pageNo, searchKey });
    };

    const handleWabaSelect = (waba) => {
        setSelectedWaba(waba);
    };

    return (
        <Row gutter={16}>
            <Col span={8}>
                <Card title='Create WABA'>
                    <WABAForm operation={'create'} />
                </Card>
            </Col>
            <Col span={8}>
                <Card title={
					<div className='d-flex justify-content-between align-items-center w-100'>
					<span>WABA List</span>
					<Search
						addonBefore="Search"
						placeholder="Enter Template Id"
						allowClear
						onSearch={(value)=>{setSearchQuery(value)}}
						style={{width: 304}}
					/>
						</div>
				}>
                    <WABAList
						waba = {selectedWaba}
                        setWaba={handleWabaSelect}
                        getDataForWaba={getDataForWaba}
                        setPage={setPage}
                    />
                </Card>
            </Col>
            <Col span={8}>
                <Card title='Update/Send WABA'>
                    {selectedWaba && (
                        <WABAForm
                            key={selectedWaba.id || selectedWaba.key} // Add a key prop
                            operation={'update'}
                            waba={selectedWaba}
                        />
                    )}
                </Card>
            </Col>
        </Row>
    );
};

export default NotificationConfigure;